import { ButtonProps, IconButton } from '@mui/material';
import { GridRenderCellParams, useGridApiContext } from '@mui/x-data-grid-premium';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

const CustomGridTreeDataGroupingCell = ({
  id,
  field,
  rowNode,
}: GridRenderCellParams) => {
  const apiRef = useGridApiContext();

  const handleClick: ButtonProps['onClick'] = (event) => {
    if (rowNode.type !== 'group') {
      return;
    }

    apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
    apiRef.current.setCellFocus(id, field);
    event.stopPropagation();
  };

  if (rowNode.type !== 'group') return null;

  return (
    <IconButton onClick={handleClick}>
      {rowNode.childrenExpanded ? <ExpandLess /> : <ExpandMore />}
    </IconButton>
  );
};

export default CustomGridTreeDataGroupingCell;
